export const NAME = "sellerOfferRequests"
export const FIREBASE_PATH_OFFER_REQUESTS = "offerRequests"
export const FIREBASE_PATH_OPEN_OFFER_REQUESTS = "openOfferRequests"
